<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        signTypeOptions: [],
        stateOptions: [],
        form: [
          { // 收款方
            label: '收款方',
            value: 'userName',
            type: 'input',
            placeholder: '请输入收款方',
          },
          { // 手机号码
            label: '手机号码',
            value: 'userPhone',
            type: 'input',
            placeholder: '请输入手机号码',
          },
          { // 主驾司机
            label: '主驾司机',
            value: 'driverName',
            type: 'input',
            placeholder: '请输入主驾司机',
          },
          { // 业务类型
            label: '业务类型',
            value: 'signType',
            type: 'select',
            default: '1',
            placeholder: '请选择业务类型',
          },
          { // 业务状态
            label: '业务状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择业务状态',
          },
          { // 流水号码
            label: '流水号码',
            value: 'flowId',
            type: 'input',
            placeholder: '请输入流水号码',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'MARGIN_TYPE,GET_TYPE',
    });
    this.searchBoxData.signTypeOptions = enumsList[0];
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
